var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.875 105.57h67.23c1.9297 0 3.4922-1.5625 3.4922-3.4922l0.003906-92.184c0-1.9297-1.5625-3.4922-3.4922-3.4922h-108.22c-1.9297 0-3.4922 1.5625-3.4922 3.4922v92.184c0 1.9297 1.5625 3.4922 3.4922 3.4922h15.086l9.9531 14.516c1.3867 2.0273 4.3477 2 5.7266 0.039063zm0.28125-65.109c-0.59375 1.832-2.5625 2.832-4.3906 2.2344-1.8281-0.59375-2.832-2.5586-2.2344-4.3906 2.6055-7.9961 10.594-13.078 19.133-13.078 10.605 0 19.98 7.8398 19.98 18.363 0 7.2031-4.5586 13.426-11.016 16.41-3.4688 1.6055-5.4766 4.7539-5.4766 8.582v3.5234c0 1.9297-1.5625 3.4922-3.4922 3.4922-1.9297 0-3.4922-1.5625-3.4922-3.4922v-3.5234c0-6.4961 3.6406-12.184 9.543-14.91 7.625-3.5195 9.3789-12.508 3.2812-18.008-4.625-4.168-12.047-4.6055-17.242-1.1055-2.1875 1.4727-3.8242 3.5312-4.5938 5.8984zm10.133 38.359c2.1797-2.2812 6.0195-0.71875 6.0195 2.4102 0 3.1719-3.9297 4.7109-6.0742 2.3477-1.2305-1.3555-1.207-3.4336 0.054687-4.7578z",
    fill: "#00abe6",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question.5e43d89bc7b02bc460e74a8f993ae09e.svg";